// ====================================================================================
// Main Entry Point - Prioritized Module Loading
// ====================================================================================
import { domReady, waitForIdle } from "./functions/utility.js";

// =========================================================================
// Cache selectors for better performance
// =========================================================================
const swiper = document.querySelector(".swiper-container") || document.querySelector(".numbers-swiper");
const eyeAble = document.querySelector(".btn--contrast");
const mainNav = document.querySelector('#main-nav1');
const contactPopupItems = document.querySelectorAll('.ctype-ce_contact_popup');
const sectionNav = document.querySelector('.section-nav');
const blogLatestFilters = document.querySelector('.blog-latest__filters');

// =========================================================================
// CRITICAL: Load immediately (blocking)
// =========================================================================
const criticalImports = [];

// Add critical imports here

if (criticalImports.length) Promise.all(criticalImports).catch(console.error);

// =========================================================================
// HIGH PRIORITY: Load after DOM ready
// =========================================================================
domReady().then(() => {
  const imports = [];

  // Add high priority imports here
  if (swiper) {
    imports.push(import("./modules/swiper.mjs").then((m) => m.init()));
  }
  if (eyeAble) {
    imports.push(import("./modules/eyeAble.mjs").then((m) => m.init()));
  }
  if (mainNav) {
    imports.push(import("./modules/mainNavHandler.mjs").then((m) => m.init()));
  }
  if (contactPopupItems.length > 0) {
    imports.push(import("./modules/ce_contact_popup.mjs").then((m) => m.init()));
  }
  if (sectionNav) {
    imports.push(import("./modules/sectionNav.mjs").then((m) => m.init()));
  }
  if (blogLatestFilters) {
    imports.push(import("./modules/blogLatestFilter.mjs").then((m) => m.init()));
  }

  if (imports.length) Promise.all(imports).catch(console.error);
});

// =========================================================================
// LOW PRIORITY: Load when browser is idle
// =========================================================================
waitForIdle().then(() => {
  const imports = [];

  // Add low priority imports here

  if (imports.length) Promise.all(imports).catch(console.error);
});
